import { useLanguage } from "../../../../context/LanguageContext";
import { Button } from "../../../../components/ui/button";
import { ArrowUpDown, Edit } from "lucide-react";
import { DataTable } from "../../../../components/DataTable";
import { SubLessonData } from "../../../../lib/languages";
import { Badge } from "../../../../components/ui/badge";
import DialogDeleteQuiz from "../../Lesson/Tabs/Quiz/DialogDeleteQuiz";
import { useNavigate } from "react-router-dom";

const TableQuizez = ({ data = [], fetchQuizzes }) => {
  const { language } = useLanguage();
  const t = SubLessonData[language] || SubLessonData["en"];

  const navigate = useNavigate();

  const columns = [
    {
      accessorKey: "title.en",
      header: ({ column }) => (
        <Button
          variant="ghost"
          className="p-0 hover:bg-transparent"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          {t.columnTitleEn}
          <ArrowUpDown className="h-4 w-4" />
        </Button>
      ),
      cell: ({ row }) => row.original.title?.en || "---",
    },
    {
      accessorKey: "title.ar",
      header: ({ column }) => (
        <Button
          variant="ghost"
          className="p-0 hover:bg-transparent"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          {t.columnTitleAr}
          <ArrowUpDown className="h-4 w-4" />
        </Button>
      ),
    },
    {
      accessorKey: "duration",
      header: t.columnDuration,
      cell: ({ row }) => <span>{row.original.duration || "---"}</span>,
    },
    {
      accessorKey: "start_date",
      header: t.columnStartDateQuiz,
      cell: ({ row }) => <span>{row.original.start_date || "---"}</span>,
    },
    {
      accessorKey: "end_date",
      header: t.columnEndDateQuiz,
      cell: ({ row }) => <span>{row.original.end_date || "---"}</span>,
    },
    {
      accessorKey: "start_time",
      header: t.columnStartTime,
      cell: ({ row }) => <span>{row.original.start_time || "---"}</span>,
    },
    {
      accessorKey: "end_time",
      header: t.columnEndTime,
      cell: ({ row }) => <span>{row.original.end_time || "---"}</span>,
    },
    {
      accessorKey: "quiz_target",
      header: t.columnQuizTarget,
      cell: ({ row }) => {
        const { lesson_id, course_id, category_id } = row.original;
        return (
          <div className="flex space-x-2">
            {lesson_id && <Badge variant="secondary">Lesson</Badge>}
            {course_id && <Badge variant="secondary">Course</Badge>}
            {category_id && <Badge variant="secondary">Category</Badge>}
            {!lesson_id && !course_id && !category_id && <span>---</span>}
          </div>
        );
      },
    },
    {
      accessorKey: "actions",
      header: t.columnActions,
      cell: ({ row }) => {
        const item = row.original;
        return (
          <div className="flex items-center gap-2">
            <Button
              variant="ghost"
              size="icon"
              className="text-green-500 h-7 w-7"
              onClick={() =>
                navigate(`/teacher/edit-quiz/teacher`, {
                  state: { isTeacher: true, bid: item.bid },
                })
              }
            >
              <Edit className="h-4 w-4" />
            </Button>
            <DialogDeleteQuiz item={item} fetchQuizzes={fetchQuizzes} />
          </div>
        );
      },
    },
  ];

  return (
    <DataTable
      columns={columns}
      data={data}
      title={t.tableQuizezTitle}
      filterNames={["title_ar", "title_en", "score"]}
    />
  );
};

export default TableQuizez;
